
interface ProductLanguageCellDelegate
{
    localizedValueCellDidInsert( cell:ProductLanguageCell, value:string, language:string ) : void;
}

class ProductLanguageCell extends UITableViewCell
{
    delegate:ProductLanguageCellDelegate = null;

    private titleLabel:MUILabel = null;
    private valueTextField:MUITextField = null;
    private valueTextArea:MUITextArea = null;

    awakeFromHTML(){
        this.titleLabel = MUIOutlet(this, "title-lbl", "MUILabel");

        this.valueTextField = MUIOutlet(this, "value-tf", "MUITextField");
        if (this.valueTextField) this.valueTextField.setOnChangeText(this, function(this:ProductLanguageCell, textField:MUITextField, value:string){
            let v = value.trim().length > 0 ? value.trim() : null;
            this.updateLocalizeValue( v );
        });

        this.valueTextArea = MUIOutlet(this, "laguage-desc-ta", "MUITextArea");
        if (this.valueTextArea) this.valueTextArea.setOnChangeText(this, function(this:ProductLanguageCell, areaTextField:MUITextArea, value:string){
            let v = value.trim().length > 0 ? value.trim() : null;
            this.updateLocalizeValue( v );
        });

        this.selectionStyle = UITableViewCellSelectionStyle.None;
    }

    set language(value:string){
        this.titleLabel.text = MIOLocalizeString( value, value );
    }

    private _localize_value: LocalizedValue = null;
    
    private _object: MIOManagedObject = null;
    private _key: string = null;
    private _language: string = null;
    setItem( value:LocalizedValue, object:MIOManagedObject, key:string, language:string ){
        this._localize_value = value;
        this._object = object;
        this._language = language;
        this._key = key;
        if (this.valueTextField != null) this.valueTextField.text = value?.value;
        if (this.valueTextArea != null) this.valueTextArea.text = value?.value;
    }

    private updateLocalizeValue( value:string ) {
        this.delegate.localizedValueCellDidInsert( this, value, this._language );
    }
}

const flags =  {
    "en": "🇬🇧",
    "es": "🇪🇸",
    "fr": "🇫🇷",
    "eu": "🇪🇺",
    "de": "🇩🇪",
    "it": "🇮🇹",
    "pt": "🇵🇹",
    "ca": "🇨🇦",
    "gl": "🇬🇱",
    "ru": "🇷🇺",
    "nl": "🇳🇱",
    "ar": "🇦🇪"
}
